// OAuth callback handler for Studio1 Alpha
// Handles error redirects from backend OAuth flow

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { logger } from "../../services/logger";
import { generateUUID } from "../../utils/uuid";

export const OAuthHandler: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const correlationId = generateUUID();

    // Check for error from backend
    const urlParams = new URLSearchParams(location.search);
    const error = urlParams.get("error");

    if (error) {
      logger.error("Auth callback error", new Error(error), {
        correlationId,
      });
      navigate("/auth?error=" + encodeURIComponent(error));
    } else {
      // No error - redirect to inspire page
      // AuthContext will handle fetching user via refreshUser() on mount
      logger.debug("OAuth callback redirecting to inspire", {
        correlationId,
      });
      navigate("/inspire?ref=auth", { replace: true });
    }
  }, [navigate, location.search]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-4" />
        <h2 className="text-lg font-medium text-gray-900 mb-2">
          Completing sign in...
        </h2>
      </div>
    </div>
  );
};
